class BlogNav extends HTMLElement {
  constructor() {
    super();
    this.current_category = this.querySelector(`[href="${window.location.pathname}"]`);
    if(!!this.current_category) this.current_category.closest('.blog-nav__category-item').classList.add('is-active');
    if(this.current_category.parentElement.parentElement.classList.contains('blog-nav__sub')) this.current_category.parentElement.classList.add('is-active');
    
    this.querySelectorAll('.blog-nav__category-item > a').forEach( category => category.addEventListener('click', (event) => {
      if(!!category.parentElement.querySelector('.blog-nav__sub') && window.innerWidth < 989) {
        event.preventDefault();
        this.querySelectorAll('.blog-nav__category-item').forEach( li => li.classList.remove('is-mobile-active'));
        category.parentElement.classList.add('is-mobile-active');
      }
    }));

    this.querySelectorAll('.on__close-nav-blog').forEach( close => {
      close.addEventListener('click', (event) => {
        event.preventDefault();
        close.closest('.blog-nav__category-item').classList.remove('is-mobile-active');
      });
    });
  }
}

customElements.define('blog-nav', BlogNav);